// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2pdaz","clinicsSelect":"TableHeading_clinicsSelect__13MV4"};